import React from "react"
import { Link, useRouteMatch } from "react-router-dom"
import {
  CalendarEvent,
  MusicNoteList,
  HeartFill,
  GraphUp,
  CashStack,
  EnvelopeFill,
} from "react-bootstrap-icons"

const navItems = [
  { label: "Events", path: "/dashboard/events", Icon: CalendarEvent },
  { label: "Performers", path: "/dashboard/bands", Icon: MusicNoteList },
  { label: "Followers", path: "/dashboard/followers", Icon: HeartFill },
  { label: "Stats", path: "/dashboard/stats", Icon: GraphUp },
  { label: "Payouts", path: "/dashboard/payouts", Icon: CashStack },
  { label: "Advance Email Text", path: "/dashboard/mailer_templates", Icon: EnvelopeFill },
]

interface NavItemProps {
  label: string
  path: string
  Icon: React.ComponentType<{ className?: string }>
}

const NavItem: React.FC<NavItemProps> = ({ label, path, Icon }) => {
  const match = useRouteMatch({ path, exact: true })
  return (
    <Link
      to={path}
      title={label}
      className={`flex items-center text-sm font-bold uppercase pb-3 border-b-2 -mb-px shrink-0 ${
        match
          ? "border-black text-black"
          : "border-transparent text-gray-500 hover:text-gray-800"
      }`}
    >
      {/* Mobile: icon only (page itself shows a title for the less-obvious
          ones). Desktop: text label only, no icon. */}
      <Icon className="w-4 h-4 shrink-0 lg:hidden" />
      <span className="hidden lg:inline">{label}</span>
    </Link>
  )
}

const DashboardNav: React.FC = () => (
  <nav className="flex justify-between md:justify-start md:gap-4 lg:gap-6 border-b border-gray-300 mb-6 overflow-x-auto">
    {navItems.map((item) => (
      <NavItem key={item.path} {...item} />
    ))}
  </nav>
)

export default DashboardNav
